import { Driver, driver } from 'driver.js';
import 'driver.js/dist/driver.css';
import { createContext, useCallback, useContext, useMemo } from 'react';

const TourManagerContext = createContext<{
	driverInstance: Driver;
}>({
	driverInstance: driver(),
});

export const TourManagerProvider = ({ children }: { children: React.ReactNode }) => {
	const driverInstance = useMemo(
		() =>
			driver({
				showProgress: true,
				allowClose: false,
				allowKeyboardControl: true,
			}),
		[]
	);

	return (
		<TourManagerContext.Provider value={{ driverInstance }}>{children}</TourManagerContext.Provider>
	);
};

export const useTourManager = () => {
	const context = useContext(TourManagerContext);

	const onStartTour = useCallback(() => {
		if (context.driverInstance.isActive()) {
			context.driverInstance.destroy();
		}

		context.driverInstance.drive();
	}, [context.driverInstance]);

	if (!context) {
		throw new Error('useTourManager must be used within a TourManagerProvider');
	}

	return { ...context, onStartTour };
};
